import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';

function Bio() {
  const {site} = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            description
          }
        }
      }
    `
  );

  return (
    <div
      style={{
        display: `flex`
      }}>
      <p>{site.siteMetadata.description}</p>
    </div>
  );
}

export default Bio;
